/**
 *  @class
 *  @function VariantSelects
 */
if (!window.VariantSelects) {
  const PERSISTENT_SLIDE = '.product-images__slide[data-persistent-slide]';
  const PERSISTENT_INITIAL_SLIDE = '.product-images__slide[data-persistent-initial="true"]';
  const PERSISTENT_INITIAL_THUMB = '.product-thumbnail[data-persistent-initial="true"]';
  const VARIANT_SLIDE = '.product-images__slide:not([data-persistent-slide])';
  const VARIANT_THUMB = '.product-thumbnail:not([data-persistent-slide])';
  const VIZBL_LOADING_TIMEOUT = 8000;

  const parseJsonScript = (element) => {
    if (!element) return null;
    try {
      return JSON.parse(element.textContent || '{}');
    } catch (error) {
      return null;
    }
  };

  window.VariantSelects = class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.addEventListener('change', (event) => {
        this.updateLabelCor(event);
      });
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });
      this.productWrapper = this.closest('.thb-product-detail');
      if (this.productWrapper) {
        this.productSlider = this.productWrapper.querySelector('.product-images') ? this.productWrapper.querySelector('.product-images') : this.productWrapper.querySelector('.product-quick-images');
        this.thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');
        this.isLP = this.productWrapper.dataset.isLp === 'true';

        if (this.productSlider) {
          this.hideVariants = this.productSlider.dataset.hideVariants === 'true';
          this.showAllMedia = this.productSlider.dataset.showAllMedia;
          this.displaySliderPagination = this.productSlider.dataset.displaySliderPagination === 'true';
          this.useSleepGallery = this.productSlider.dataset.sleepGallery === 'true';

          this.sleepVariantsData = this.useSleepGallery
            ? parseJsonScript(this.closest('.product-section-sleep')?.querySelector('.main-product-sleep-variants-json'))
            : null;

          this.vizblData = parseJsonScript(document.getElementById(`VizblData-${this.dataset.section}`));
        }
      } else {
        this.useSleepGallery = false;
        this.sleepVariantsData = null;
      }

      if (typeof this.initMediaManager === 'function') {
        this.initMediaManager();
      } else {
        this.mediaManagerData = null;
        this.useMediaManager = false;
      }
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.reorderVariantsByAvailability();
      this.setImageSet();
      this.updateScarcityWarning();
      this.updateMedia();
      this.syncMediaOverlayActions();
      this.updateDimensions();
      this.updateNewColorSwatches();
      this.initializeLabels();
      this.updateVariantText();
      this.updateProductLinkButtons();
      this.selectInitialPersistentSlide();
    }

    hasPersistentInitialSlide() {
      return Boolean(this.productSlider?.querySelector(PERSISTENT_INITIAL_SLIDE));
    }

    selectInitialPersistentSlide() {
      const slide = this.productSlider?.querySelector(PERSISTENT_INITIAL_SLIDE);
      if (!slide) return;

      slide.classList.add('is-active', 'is-initial-selected');

      if (this.thumbnails) {
        const thumb = this.thumbnails.querySelector(PERSISTENT_INITIAL_THUMB);
        this.thumbnails.querySelectorAll('.product-thumbnail.is-initial-selected').forEach((el) => {
          if (el !== thumb) el.classList.remove('is-initial-selected');
        });
        thumb?.classList.add('is-active', 'is-initial-selected');
      }

      if (typeof Flickity !== 'undefined' && Flickity.data(this.productSlider)) {
        this.productSlider.selectCell(`#${slide.id}`, false, true);
      } else {
        this.productSlider.scrollTo({ left: 0, behavior: 'instant' });
      }
    }
    formatPriceUSD(value) {
      return (value / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    }
    onVariantChange(event) {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();
      this.reorderVariantsByAvailability();

      if (this.autoSelectVisibleColor()) {
        return;
      }

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {

        if (event.originalTarget) {
          const value = event?.originalTarget?.value ?? null;
          const variants = window.pricesProductsVariant
          if (value && variants && this.isLP) {
            const matchedVariant = variants.find(variant => variant.id === this.currentVariant.id);
            const sectionPrice = this.productWrapper?.querySelector(`[id="price-${this.dataset.section}"]`);
            const elementPrice = sectionPrice?.closest('.product-price-container')
              || this.productWrapper?.querySelector('.product-price-container.layout-model_2')
              || this.productWrapper?.querySelector('.product-price-container');
            if (elementPrice && matchedVariant) {
              const amount = elementPrice.querySelector('del span.amount');        // preço "de"
              const discounted = elementPrice.querySelector('ins span.discounted'); // preço "por"
              // atualiza DOM
              if (amount) {
                amount.textContent = this.formatPriceUSD(matchedVariant.preco_de);
              }

              if (discounted) {
                discounted.textContent = this.formatPriceUSD(matchedVariant.preco_por);
              }

            }

          }
        }
        this.updateMedia();
        this.syncMediaOverlayActions();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();

        if (this.isLP) this.renderProductInfoForLPs();
        else this.renderProductInfo();
        this.updateProductLinkButtons();
        this.selectInitialPersistentSlide();
      }
      this.updateOther();
      this.updateScarcityWarning();
      this.updateDimensions();
      this.updateNewColorSwatches();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.option_keys = [];

      this.fieldsets.forEach(fieldset => {
        const select = fieldset.querySelector('select');
        const inputs = fieldset.querySelectorAll('input');

        if (select) {
          this.options.push(select.value);
          this.option_keys.push(select.name);
        } else if (inputs.length) {
          const checkedInput = fieldset.querySelector('input:checked');
          this.options.push(checkedInput?.value || '');
          this.option_keys.push(inputs[0].name);
        }
      });

      this.dataset.options = this.options;
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));

      fieldsets.forEach((fieldset, i) => {
        if (this.shouldSkipColorFieldset(fieldset)) return;

        const optionValue = this.options[i];
        if (!optionValue) return;

        this.updateFieldsetLabel(fieldset, optionValue);
      });
    }

    shouldSkipColorFieldset(fieldset) {
      const handle = fieldset.dataset.handle || '';
      const isColorFieldset = handle.toLowerCase() === 'color' ||
        fieldset.classList.contains('fieldset--color');
      return isColorFieldset;
    }

    updateFieldsetLabel(fieldset, value) {
      let label = fieldset.querySelector('.form__label__value');

      if (label) {
        label.innerHTML = value;
      } else {
        this.createFieldsetLabel(fieldset, value);
      }
    }

    createFieldsetLabel(fieldset, value) {
      const labelContainer = fieldset.querySelector('.form__label');
      if (!labelContainer) return;

      const label = document.createElement('span');
      label.className = 'form__label__value';
      label.innerHTML = value;
      labelContainer.appendChild(label);
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value="${option}"]`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateScarcityWarning() {
      const container = document.getElementById('scarcity-warning-container');
      const textElement = document.getElementById('scarcity-warning-text');

      if (!container) return;

      const showContainer = (content = null) => {
        container.style.display = 'inline-flex';
        container.classList.remove('scarcity-warning-hidden');
        if (content && textElement) {
          textElement.innerHTML = content;
        }
      };

      const hideContainer = () => {
        container.style.display = 'none';
        container.classList.add('scarcity-warning-hidden');
      };

      const isValidValue = (value) => {
        return value && value !== "" && value !== null && value !== "null";
      };

      const getScarcityMetafield = (metafieldsData) => {
        if (!this.currentVariant) return null;

        const variantMetafield = metafieldsData.variants?.[this.currentVariant.id];
        const productMetafield = metafieldsData.product;

        return isValidValue(variantMetafield)
          ? variantMetafield
          : (isValidValue(productMetafield) ? productMetafield : null);
      };

      if (!this.currentVariant) {
        const hasInitialContent = textElement?.textContent?.trim();
        return hasInitialContent ? showContainer() : hideContainer();
      }

      const metafieldsScript = document.querySelector(`#variant-metafields-${this.dataset.section}`);
      if (!metafieldsScript) return;

      try {
        const metafieldsData = JSON.parse(metafieldsScript.textContent);
        const scarcityMetafield = getScarcityMetafield(metafieldsData);

        if (isValidValue(scarcityMetafield)) {
          showContainer(scarcityMetafield);
        } else {
          hideContainer();
        }
      } catch (e) {
        console.error('Error parsing scarcity warning metafields:', e);
        hideContainer();
      }
    }

    updateDimensions() {
      const metafieldsScript = document.querySelector(`#variant-metafields-${this.dataset.section}`);
      if (!metafieldsScript) return;

      try {
        const metafieldsData = JSON.parse(metafieldsScript.textContent);
        const dimensionData = metafieldsData.dimensions;
        if (!dimensionData) return;
        const fieldsets = this.querySelectorAll('fieldset');

        fieldsets.forEach((fieldset) => {
          const optionName = fieldset.querySelector('.form__label')?.textContent?.toLowerCase() || '';
          const isSizeOption = optionName.includes('size') || optionName.includes('tamanho');

          if (!isSizeOption) return;

          let selectedValue = '';
          const select = fieldset.querySelector('select');
          const checkedInput = fieldset.querySelector('input:checked');

          if (select) {
            selectedValue = select.value;
          } else if (checkedInput) {
            selectedValue = checkedInput.value;
          }

          if (!selectedValue) return;

          const dimensionItem = dimensionData.find(item => {
            return item.size.toUpperCase() === selectedValue.toUpperCase();
          });

          let dimensionWrapper = fieldset.querySelector('.product-option-dimension-wrapper');
          let dimensionElement = dimensionWrapper ? dimensionWrapper.querySelector('.product-option-dimension, .form__label__value-dimension') : null;

          if (dimensionItem) {
            if (!dimensionWrapper) {
              dimensionWrapper = document.createElement('div');
              dimensionWrapper.className = 'product-option-dimension-wrapper';
              fieldset.appendChild(dimensionWrapper);
            }

            if (!dimensionElement) {
              dimensionElement = document.createElement('div');
              dimensionElement.className = 'product-option-dimension form__label__value-dimension';

              const existingStyledElement = fieldset.querySelector('.product-option-dimension[style], .form__label__value-dimension[style]');
              if (existingStyledElement && existingStyledElement.style.cssText) {
                dimensionElement.style.cssText = existingStyledElement.style.cssText;
              }

              dimensionWrapper.appendChild(dimensionElement);
            }
            dimensionElement.setAttribute('data-size', selectedValue);

            const textElement = dimensionElement.querySelector('.product-option-dimension__text') || document.createElement('span');
            textElement.className = 'product-option-dimension__text';
            textElement.textContent = dimensionItem.dimension;
            if (!dimensionElement.querySelector('.product-option-dimension__text')) {
              dimensionElement.appendChild(textElement);
            }
            dimensionWrapper.style.display = '';
            dimensionElement.style.display = '';
          } else if (dimensionWrapper) {
            dimensionWrapper.style.display = 'none';
          }
        });
      } catch (error) {
        console.error('Error updating product option dimensions:', error);
      }
    }

    updateNewColorSwatches() {
      const isEnabled = window.theme?.settings?.color_swatches_new_tag_enable;
      if (isEnabled !== true) {
        this.removeNewColorSwatches();
        return;
      }

      const badgeText = window.theme?.settings?.color_swatches_new_tag_text?.trim();
      if (!badgeText) return;

      const metafieldsScript = document.querySelector(`#variant-metafields-${this.dataset.section}`);
      if (!metafieldsScript) return;

      let metafieldsData = null;
      try {
        metafieldsData = JSON.parse(metafieldsScript.textContent);
      } catch (error) {
        console.error('Error parsing new colors metafields:', error);
        return;
      }

      const newColors = this.parseNewColors(metafieldsData?.new_colors);
      if (!newColors.length) return;

      const newColorsSet = new Set(newColors.map((color) => this.normalizeColorName(color)));
      const badgeColor = window.theme?.settings?.color_swatches_new_tag_color || '#956793';
      const badgeTextColor = window.theme?.settings?.color_swatches_new_tag_text_color || '#ffffff';
      const borderWidth = parseInt(window.theme?.settings?.color_swatches_new_tag_border_width || 3);
      const fontSize = parseInt(window.theme?.settings?.color_swatches_new_tag_font_size || 10);
      const fieldsets = this.querySelectorAll('.product-form__input--color');

      fieldsets.forEach((fieldset) => {
        const inputs = fieldset.querySelectorAll('input[type="radio"]');
        inputs.forEach((input) => {
          const value = input.value ? input.value.trim() : '';
          if (!value) return;

          const label = fieldset.querySelector(`label[for="${input.id}"]`);
          if (!label) return;

          const isNew = newColorsSet.has(this.normalizeColorName(value));
          label.classList.toggle('swatch-is-new', isNew);

          let badge = label.querySelector('.swatch-new-badge');
          if (isNew) {
            if (!badge) {
              badge = document.createElement('span');
              badge.className = 'swatch-new-badge';
              label.appendChild(badge);
            }
            badge.textContent = badgeText;
            label.style.setProperty('--swatch-new-color', badgeColor);
            label.style.setProperty('--swatch-new-text-color', badgeTextColor);
            label.style.setProperty('--swatch-new-border-width', `${borderWidth}px`);
            label.style.setProperty('--swatch-new-font-size', `${fontSize}px`);
          } else if (badge) {
            badge.remove();
          }
        });
      });
    }

    removeNewColorSwatches() {
      const fieldsets = this.querySelectorAll('.product-form__input--color');
      fieldsets.forEach((fieldset) => {
        const labels = fieldset.querySelectorAll('label.swatch-is-new');
        labels.forEach((label) => {
          label.classList.remove('swatch-is-new');
          const badge = label.querySelector('.swatch-new-badge');
          if (badge) {
            badge.remove();
          }
          label.style.removeProperty('--swatch-new-color');
          label.style.removeProperty('--swatch-new-text-color');
          label.style.removeProperty('--swatch-new-border-width');
          label.style.removeProperty('--swatch-new-font-size');
        });
      });
    }

    normalizeColorName(value) {
      return value.toString().trim().toLowerCase();
    }

    initializeLabels() {
      this.ensureVariantsColors();
      const colorFieldsets = this.getColorFieldsets();

      colorFieldsets.forEach(fieldset => {
        const selectedInput = this.getSelectedInput(fieldset);
        if (selectedInput) {
          this.updateLabelCor({ target: selectedInput, isInitialization: true });
        }
      });
    }

    ensureVariantsColors() {
      if (!window.variantsColors) {
        window.variantsColors = [];
      }
    }

    getColorFieldsets() {
      return Array.from(this.querySelectorAll('fieldset')).filter(fieldset => {
        const handle = fieldset.dataset.handle || '';
        return handle.toLowerCase() === 'color' || fieldset.classList.contains('fieldset--color');
      });
    }

    getSelectedInput(fieldset) {
      return fieldset.querySelector('input:checked') ||
        fieldset.querySelector('select')?.selectedOptions[0];
    }

    updateLabelCor(event) {
      this.ensureVariantsColors();

      if (!event?.target) return;

      const targetFieldset = event.target.closest('fieldset');
      if (!targetFieldset || !this.isColorFieldset(targetFieldset)) return;

      const selectedValue = event.target.value;
      if (!selectedValue) return;

      if (!window.variantsColors?.length) {
        this.setBasicColorLabel(targetFieldset, selectedValue);
        return;
      }

      const variantsData = this.findVariantsData(targetFieldset);
      if (!variantsData?.variants?.length) {
        this.setBasicColorLabel(targetFieldset, selectedValue);
        return;
      }

      const matchedVariant = this.findMatchedVariant(variantsData, selectedValue);
      if (!matchedVariant) {
        this.setBasicColorLabel(targetFieldset, selectedValue);
        return;
      }

      const hasMaterial = matchedVariant.title_material && matchedVariant.content_material;
      const hasColorTitle = matchedVariant.title_color?.trim();

      if (!hasMaterial && !hasColorTitle && !selectedValue) return;

      const separator = matchedVariant.separator || '|';
      const hasGroupColors = targetFieldset.dataset.isGrouped === 'true';

      if (hasGroupColors) {
        this.updateGroupedColorLabel(targetFieldset, event, matchedVariant, selectedValue, separator, hasMaterial);
      } else {
        this.updateSingleColorLabel(targetFieldset, matchedVariant, separator, selectedValue, hasMaterial, hasColorTitle);
      }
    }

    isColorFieldset(fieldset) {
      const handle = fieldset.dataset.handle || '';
      return handle.toLowerCase() === 'color' || fieldset.classList.contains('fieldset--color');
    }

    findVariantsData(fieldset) {
      const handle = fieldset.dataset.handle || '';
      return window.variantsColors.find(vc => vc.optionHandle === handle) ||
        window.variantsColors.find(vc => vc.optionHandle === 'color' || vc.optionHandle === 'colour') ||
        window.variantsColors[0];
    }

    findMatchedVariant(variantsData, selectedValue) {
      for (const variantColor of variantsData.variants) {
        if (variantColor.metaobject_colors?.values) {
          for (const color of variantColor.metaobject_colors.values) {
            if (color.label === selectedValue) {
              return variantColor;
            }
          }
        }
      }
      return null;
    }

    setBasicColorLabel(targetFieldset, selectedValue) {
      const hasGroupColors = targetFieldset.dataset.isGrouped === 'true';

      if (hasGroupColors) {
        this.updateGroupedSummaryLabel(targetFieldset, `<strong>Color:</strong>`, selectedValue);
        return;
      }

      const label = targetFieldset.querySelector('.form__label__text');
      if (!label) return;

      const optionName = targetFieldset.querySelector('.form__label')?.textContent?.split(':')[0] || 'Color';
      const colorValue = `<span class="form__label__color-value">${this.escapeHTML(selectedValue)}</span>`;
      label.innerHTML = `<strong>${this.escapeHTML(optionName)}:</strong> ${colorValue}`;

      const valueLabel = targetFieldset.querySelector('.form__label__value');
      if (valueLabel) {
        valueLabel.innerHTML = '';
      }
    }

    updateGroupedColorLabel(targetFieldset, event, matchedVariant, selectedValue, separator, hasMaterial) {
      const groupId = event.target.getAttribute('data-group-id');
      if (!groupId) return;

      const selectedContainer = targetFieldset.querySelector(`[data-color-group="${groupId}"]`);
      if (!selectedContainer) return;

      selectedContainer.textContent = '';

      const hasColorTitle = Boolean(matchedVariant?.title_color);
      const html = this.buildLabelHTML(
        matchedVariant,
        separator,
        selectedValue,
        hasMaterial,
        hasColorTitle
      );
      this.updateGroupedSummaryLabel(targetFieldset, html, '');
    }

    updateGroupedSummaryLabel(targetFieldset, labelHTML, value = '') {
      const summaryLabel = targetFieldset.querySelector('.product-form__grouped-summary .form__label__text');
      const summaryValue = targetFieldset.querySelector('.product-form__grouped-summary .form__label__value');

      if (summaryLabel) {
        summaryLabel.innerHTML = labelHTML;
      }
      if (summaryValue) {
        summaryValue.innerHTML = value ? this.escapeHTML(value) : '';
      }
    }

    updateSingleColorLabel(targetFieldset, matchedVariant, separator, selectedValue, hasMaterial, hasColorTitle) {
      const label = targetFieldset.querySelector('.form__label__text');
      if (!label) return;

      const html = this.buildLabelHTML(matchedVariant, separator, selectedValue, hasMaterial, hasColorTitle);
      label.innerHTML = html;

      const valueInHTML = (!hasMaterial && selectedValue) || hasColorTitle;
      this.updateValueLabel(targetFieldset, selectedValue, hasColorTitle, valueInHTML);
    }

    buildLabelHTML(matchedVariant, separator, selectedValue, hasMaterial, hasColorTitle) {
      const normalizeTitle = (title) => {
        if (!title) return '';
        const normalized = this.escapeHTML(title).trim();
        return normalized.endsWith(':') ? normalized.slice(0, -1) : normalized;
      };

      let html = '';

      if (hasMaterial) {
        const materialTitle = normalizeTitle(matchedVariant.title_material);
        const materialLabel = `<strong>${materialTitle}:</strong>`;
        const materialValue = `<span class="form__label__material-value">${this.escapeHTML(matchedVariant.content_material)}</span>`;

        const separatorHTML = (hasColorTitle || selectedValue) && separator
          ? ` <span class="form__label__separator">${this.escapeHTML(separator)}</span>`
          : '';

        html += `<span class="form__label__material-section">${materialLabel} ${materialValue}${separatorHTML}</span>`;
      }

      if (hasColorTitle || (!hasMaterial && selectedValue)) {
        const colorTitle = hasColorTitle
          ? normalizeTitle(matchedVariant.title_color)
          : 'Color';
        const colorLabel = `<strong>${colorTitle}:</strong>`;
        const colorValue = `<span class="form__label__color-value">${this.escapeHTML(selectedValue)}</span>`;
        const colorSection = `<span class="form__label__color-section">${colorLabel} ${colorValue}</span>`;

        if (html) {
          html += ` ${colorSection}`;
        } else {
          html = colorSection;
        }
      }

      return html;
    }

    updateValueLabel(targetFieldset, selectedValue, hasColorTitle, valueInHTML = false) {
      let valueLabel = targetFieldset.querySelector('.form__label__value');

      if (valueInHTML) {
        if (valueLabel) {
          valueLabel.innerHTML = '';
        }
        return;
      }

      if (!hasColorTitle && selectedValue) {
        if (!valueLabel) {
          const labelContainer = targetFieldset.querySelector('.form__label__container');
          if (labelContainer) {
            valueLabel = document.createElement('span');
            valueLabel.className = 'form__label__value';
            labelContainer.appendChild(valueLabel);
          }
        }
        if (valueLabel) {
          valueLabel.innerHTML = selectedValue;
        }
      }
    }

    escapeHTML(str) {
      if (!str) return '';
      const div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    parseNewColors(rawValue) {
      if (!rawValue) return [];
      if (Array.isArray(rawValue)) return rawValue;
      if (typeof rawValue === 'string') {
        const trimmed = rawValue.trim();
        if (!trimmed || trimmed === 'null' || trimmed === 'undefined') return [];
        if (trimmed[0] === '[') {
          try {
            const parsed = JSON.parse(trimmed);
            if (Array.isArray(parsed)) {
              return parsed;
            }
          } catch (error) {
            return trimmed.split(',').map((value) => value.trim()).filter(Boolean);
          }
        }
        return trimmed.split(',').map((value) => value.trim()).filter(Boolean);
      }
      return [];
    }

    updateSleepGalleryMedia() {
      if (!this.sleepVariantsData || !this.productSlider) return;

      const payload = this.sleepVariantsData?.[String(this.currentVariant?.id)];
      const list = payload?.sleep_media_list;
      if (!Array.isArray(list) || !list.length) return;

      const ids = list
        .map((m) => (m && (m.id ?? m.media_id)) || null)
        .filter((id) => id !== null)
        .map((id) => String(id));
      if (!ids.length) return;

      const idSet = new Set(ids);
      const getSlideMediaId = (slide) => {
        const dataId = slide?.dataset?.mediaId || '';
        return dataId ? String(dataId.split('-').pop()) : null;
      };
      const getThumbMediaId = (thumb) => {
        const idAttr = thumb?.id || '';
        return idAttr ? String(idAttr.split('-').pop()) : null;
      };

      const slides = Array.from(this.productSlider.querySelectorAll(VARIANT_SLIDE));
      const slideMap = new Map(); // mediaId -> slide element
      slides.forEach((slide) => {
        const mediaId = getSlideMediaId(slide);
        if (!mediaId) return;
        if (!slideMap.has(mediaId)) slideMap.set(mediaId, slide);
      });

      const orderedSlides = ids.map((id) => slideMap.get(id)).filter(Boolean);
      const firstId = (ids.find((id) => slideMap.has(id)) || null);

      // Slides (images/videos) - toggle state + reorder DOM to match sleep_media_list order
      slides.forEach((slide) => {
        const mediaId = getSlideMediaId(slide);
        const shouldBeActive = mediaId && idSet.has(mediaId);
        slide.classList.toggle('is-active', shouldBeActive);
        slide.classList.toggle(
          'is-initial-selected',
          Boolean(shouldBeActive && firstId && mediaId === firstId)
        );
      });

      if (slides.length) {
        const slidesParent = slides[0]?.parentElement || this.productSlider;
        const remainingSlides = slides.filter((s) => {
          const mediaId = getSlideMediaId(s);
          return !mediaId || !idSet.has(mediaId);
        });
        [...orderedSlides, ...remainingSlides].forEach((node) => {
          if (node && slidesParent) slidesParent.appendChild(node);
        });
      }

      // Thumbnails (keep order consistent with slides)
      if (this.thumbnails) {
        const thumbs = Array.from(this.thumbnails.querySelectorAll(VARIANT_THUMB));
        const thumbMap = new Map(); // mediaId -> thumb element
        thumbs.forEach((thumb) => {
          const mediaId = getThumbMediaId(thumb);
          if (!mediaId) return;
          if (!thumbMap.has(mediaId)) thumbMap.set(mediaId, thumb);
        });

        const orderedThumbs = ids.map((id) => thumbMap.get(id)).filter(Boolean);
        const thumbsParent = thumbs[0]?.parentElement || this.thumbnails;
        const remainingThumbs = thumbs.filter((t) => {
          const mediaId = getThumbMediaId(t);
          return !mediaId || !idSet.has(mediaId);
        });

        // Toggle state
        thumbs.forEach((thumb) => {
          const mediaId = getThumbMediaId(thumb);
          const shouldBeActive = mediaId && idSet.has(mediaId);
          thumb.classList.toggle('is-active', shouldBeActive);
          thumb.classList.toggle(
            'is-initial-selected',
            Boolean(shouldBeActive && firstId && mediaId === firstId)
          );
        });

        // Reorder DOM to match sleep_media_list
        if (thumbsParent) {
          [...orderedThumbs, ...remainingThumbs].forEach((node) => {
            if (node) thumbsParent.appendChild(node);
          });
        }
      }

      // Update counter (mobile pagination)
      const totalEl = this.productWrapper?.querySelector('.slider-counter--total');
      if (totalEl) totalEl.textContent = ids.length;

      this.ensurePersistentMedia();

      // Tell Flickity to show the first desired media
      if (firstId) {
        const flkty = Flickity.data(this.productSlider);
        const mediaSelector = `#Slide-${this.dataset.section}-${firstId}`;
        const thumbSelector = `#Thumb-${this.dataset.section}-${firstId}`;
        const rebuiltBySlider = this.hideVariants && this.productSlider.querySelector(mediaSelector);

        if (flkty && !rebuiltBySlider && typeof this.productSlider.reInit === 'function') {
          this.productSlider.reInit(this.imageSetIndex);
        }

        this.setActiveMediaSlider(mediaSelector, thumbSelector, this.productSlider);
      }
    }

    _showAllMediaSlides() {
      if (!this.productSlider) return;

      const slides = Array.from(this.productSlider.querySelectorAll(VARIANT_SLIDE));
      const thumbs = this.thumbnails
        ? Array.from(this.thumbnails.querySelectorAll(VARIANT_THUMB))
        : [];

      slides.forEach((slide, i) => {
        slide.classList.add('is-active');
        slide.classList.remove('media-manager-hidden');
        slide.classList.toggle('is-initial-selected', i === 0);
      });

      thumbs.forEach((thumb, i) => {
        thumb.classList.add('is-active');
        thumb.classList.remove('media-manager-hidden');
        thumb.classList.toggle('is-initial-selected', i === 0);
      });

      const totalEl = this.productWrapper?.querySelector('.slider-counter--total');
      if (totalEl) totalEl.textContent = slides.length;

      this.ensurePersistentMedia();

      if (typeof this.productSlider.reInit === 'function') {
        this.productSlider.reInit(null);
      }
    }

    selectCellUnlessPinned(mediaSelector) {
      if (this.hasPersistentInitialSlide()) return;
      this.productSlider.selectCell(mediaSelector);
    }

    ensurePersistentMedia() {
      if (!this.productSlider) return;

      const hasPersistentSlides = this.positionPersistentItems(this.productSlider, '.product-images__slide');

      if (this.thumbnails) {
        this.positionPersistentItems(this.thumbnails, '.product-thumbnail');
      }

      if (!hasPersistentSlides) return;

      const totalEl = this.productWrapper?.querySelector('.slider-counter--total');
      if (totalEl) {
        totalEl.textContent = this.productSlider.querySelectorAll('.product-images__slide.is-active').length;
      }
    }

    positionPersistentItems(container, itemSelector) {
      const persistentItems = [];
      const siblings = [];

      container.querySelectorAll(itemSelector).forEach((el) => {
        if (el.dataset.persistentSlide) persistentItems.push(el);
        else if (el.classList.contains('is-active')) siblings.push(el);
      });

      if (!persistentItems.length) return false;

      persistentItems.forEach((item) => {
        item.classList.add('is-active');

        if (item.dataset.persistentInitial !== 'true') {
          item.classList.remove('is-initial-selected');
        }

        if (!siblings.length) return;

        const position = parseInt(item.dataset.slidePosition, 10) || 1;
        const targetIndex = Math.min(position - 1, siblings.length);
        const currentIndex = siblings.filter(
          (el) => item.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_PRECEDING
        ).length;

        if (currentIndex === targetIndex) return;

        const reference = siblings[targetIndex];

        if (reference) reference.before(item);
        else siblings[siblings.length - 1].after(item);
      });

      return true;
    }

    syncMediaOverlayActions() {
      this.observeMediaOverlayActions();
      if (this.hasPersistentInitialSlide()) return;

      const overlay = this.productSlider?.querySelector('.product-media-overlay-actions');
      if (!overlay) return;

      const target =
        this.productSlider.querySelector(`${VARIANT_SLIDE}.is-active.is-initial-selected`) ||
        this.productSlider.querySelector(`${VARIANT_SLIDE}.is-active`);

      if (!target || target === overlay.parentElement) return;

      target.prepend(overlay);
    }

    // Exposes where the size guide / Vizbl buttons end so the top-left badges can stack below them.
    observeMediaOverlayActions() {
      const slider = this.productSlider;
      const overlay = slider?.querySelector('.product-media-overlay-actions');
      if (!slider || !overlay || slider.mediaOverlayActions === overlay) return;

      slider.mediaOverlayActions = overlay;
      slider.mediaOverlayObserver?.disconnect();

      const update = () => {
        const media = overlay.parentElement?.querySelector('.product-single__media');
        if (!overlay.isConnected || !overlay.offsetHeight || !media) return;

        const offset = overlay.getBoundingClientRect().bottom - media.getBoundingClientRect().top + 8;
        slider.style.setProperty('--media-overlay-actions-offset', `${Math.round(offset)}px`);
      };

      slider.mediaOverlayObserver = new ResizeObserver(update);
      slider.mediaOverlayObserver.observe(overlay);
      slider.mediaOverlayObserver.observe(slider);
    }

    vizblVariantValue() {
      return this.vizblData?.variants?.[String(this.currentVariant.id)] || '';
    }

    vizblFrameSource(frame) {
      const variantValue = this.vizblVariantValue();
      const base = frame.dataset.vizblBase;

      return variantValue ? `${base}/${variantValue}` : base;
    }

    trackVizblLoading(holder, frame) {
      window.clearTimeout(this.vizblLoadingTimeout);
      holder.classList.add('is-vizbl-loading');

      const settle = () => {
        if (!frame.isConnected) return;
        window.clearTimeout(this.vizblLoadingTimeout);
        holder.classList.remove('is-vizbl-loading');
      };

      frame.addEventListener('load', settle, { once: true });
      frame.addEventListener('error', settle, { once: true });
      this.vizblLoadingTimeout = window.setTimeout(settle, VIZBL_LOADING_TIMEOUT);
    }

    updateVizblSource() {
      const frame = this.productSlider?.querySelector('[data-vizbl-base]');
      if (!frame) return;

      const src = this.vizblFrameSource(frame);
      if (frame.getAttribute('src') === src) return;

      const next = frame.cloneNode(false);
      next.setAttribute('src', src);
      next.setAttribute('loading', 'lazy');

      this.trackVizblLoading(frame.parentElement, next);
      frame.replaceWith(next);
    }

    updateVizblDimensionsButton() {
      const button = this.productWrapper?.querySelector('.vizbl_3d_view[data-object-tinuuid]');
      if (!button) return;

      const hid = this.vizblVariantValue();
      if (button.dataset.objectHid === hid) return;

      const refreshed = button.cloneNode(true);
      refreshed.dataset.objectHid = hid;
      button.replaceWith(refreshed);

      if (document.readyState === 'complete') {
        window.vizbl?.initModalButton?.('vizbl_3d_view');
      }
    }

    vizblThumbnailAlt(thumb) {
      return [thumb.dataset.vizblAltPrefix, this.currentVariant.title]
        .filter((part) => part && part !== 'Default Title')
        .join(' - ');
    }

    vizblThumbnailSource() {
      const thumbnails = this.vizblData?.thumbnails;
      const entry =
        thumbnails?.[String(this.currentVariant.id)] || thumbnails?.default || thumbnails?.fallback;

      if (entry) return entry;

      const reference =
        this.thumbnails.querySelector(`${VARIANT_THUMB}.is-active.is-initial-selected > img`) ||
        this.thumbnails.querySelector(`${VARIANT_THUMB}.is-active > img`);

      if (!reference) return null;

      return {
        src: reference.currentSrc || reference.getAttribute('src') || reference.dataset.src,
        srcset: reference.getAttribute('srcset') || reference.dataset.srcset,
        alt: reference.alt,
      };
    }

    updateVizblThumbnail() {
      const thumb = this.thumbnails?.querySelector('.product-thumbnail--vizbl');
      const image = thumb?.querySelector(':scope > img');
      if (!image) return;

      const source = this.vizblThumbnailSource();
      if (!source?.src) return;

      if (image.getAttribute('src') !== source.src) {
        if (source.srcset) {
          image.setAttribute('srcset', source.srcset);
          image.dataset.srcset = source.srcset;
        } else {
          image.removeAttribute('srcset');
          delete image.dataset.srcset;
        }

        image.setAttribute('src', source.src);
        image.dataset.src = source.src;
      }

      image.alt = source.alt || this.vizblThumbnailAlt(thumb);
    }

    updateVizbl() {
      this.updateVizblSource();
      this.updateVizblDimensionsButton();
      this.updateVizblThumbnail();
    }

    updateMedia() {
      if (!this.currentVariant) return;

      if (this.useSleepGallery) {
        this.updateSleepGalleryMedia();
      } else if (this.useMediaManager && typeof this.applyMediaManagerFilter === 'function') {
        this.applyMediaManagerFilter();
      } else if (this.currentVariant.featured_media && this.productSlider) {
        const mediaId = `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`;

        if (this.thumbnails) {
          this.setActiveMediaSlider(mediaId, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, this.productSlider);
        } else {
          this.setActiveMedia(this.productSlider.querySelector(mediaId));
        }
      }

      this.updateVizbl();
    }

    setActiveMedia(activeMedia) {
      if (!activeMedia) return;

      this.productSlider.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });

      this.setImageSetMedia();

      activeMedia.classList.add('is-active');

      activeMedia.parentElement.prepend(activeMedia);

      this.ensurePersistentMedia();

      if (!this.sticky) {
        window.setTimeout(() => {
          if (window.innerWidth > 1068) {
            let header_h = activeMedia.parentElement.offsetTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')),
              scroll_obj = {
                left: 0,
                behavior: 'instant'
              };

            if (header_h > 0) {
              scroll_obj.top = header_h;
            }
            window.scrollTo(scroll_obj);
          }
          const keepsPersistentSlideInPlace =
            this.productSlider.querySelector(PERSISTENT_SLIDE) && !this.hasPersistentInitialSlide();

          if (keepsPersistentSlideInPlace) {
            activeMedia.scrollIntoView({
              behavior: 'instant',
              inline: 'start',
              block: 'nearest'
            });
          } else {
            activeMedia.parentElement.scrollTo({
              left: 0,
              behavior: 'instant'
            });
          }
        });
      }
    }
    setActiveMediaSlider(mediaId, thumbId, productSlider) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelector(mediaId);

      if (!activeMedia) return;

      if (flkty && this.hideVariants) {
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide.is-initial-selected:not([data-persistent-initial="true"])'), function (el) {
          el.classList.remove('is-initial-selected');
        });
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });
        if (this.thumbnails) {
          [].forEach.call(this.thumbnails.querySelectorAll('.product-thumbnail.is-initial-selected'), function (el) {
            el.classList.remove('is-initial-selected');
          });
          [].forEach.call(this.thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });
        }

        activeMedia.classList.add('is-active');
        if (!this.hasPersistentInitialSlide()) {
          activeMedia.classList.add('is-initial-selected');
        }

        this.setImageSetMedia();

        if (this.thumbnails) {
          let activeThumb = this.thumbnails.querySelector(thumbId);
          if (activeThumb) {
            activeThumb.classList.add('is-active');
            activeThumb.classList.add('is-initial-selected');
          }
        }

        this.ensurePersistentMedia();

        productSlider.reInit(this.imageSetIndex);
        this.selectCellUnlessPinned(mediaId);

      } else if (flkty) {
        this.ensurePersistentMedia();
        this.selectCellUnlessPinned(mediaId);
      } else {
        // Slider not initialized yet (product.js runs before product-thumbnails.js):
        // position the persistent slides now so Flickity picks up the right order.
        this.ensurePersistentMedia();
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    updateProductLinkButtons() {
      if (!this.currentVariant || !this.dataset.url) return;
      const scope = this.closest('section') || this.closest('.thb-product-detail');
      if (!scope) return;
      const links = scope.querySelectorAll('a[data-update-variant-href="true"]');
      const href = `${this.dataset.url}?variant=${this.currentVariant.id}`;
      links.forEach((link) => {
        link.href = href;
      });
    }

    badgesSlideSelector() {
      if (this.closest('.product-grid-container')?.classList.contains('media-layout-thumbnails')) {
        return '.product-images__slide.is-initial-selected';
      }
      return '.product-images__slide:first-child';
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`, `badges-${this.dataset.section}`];
    }

    async fetchProductSectionData(url) {
      return fetch(url)
        .then((response) => response.json())
        .then((data) => data)
        .catch((error) => {
          console.error('fetchProductSectionData error:', error);
          return null;
        });
    }

    renderProductInfoForLPs() {
      const sections = this.getSectionsToRender();
      const sectionId = this.dataset.section;

      const selectedSlideSelector = this.badgesSlideSelector();

      const badgesWrapper = document.querySelector(`${selectedSlideSelector} .product-card--badges-pdp-wrapper`);
      if (badgesWrapper) badgesWrapper.classList.add('is-updating');

      const url = new URL(window.location.href);
      url.searchParams.set('fetch_featured_product', this.dataset.productHandle);

      if (this.currentVariant?.id) url.searchParams.set('fetch_featured_variant', this.currentVariant.id);
      else url.searchParams.delete('fetch_featured_variant');

      url.searchParams.set('sections', sectionId);

      this.fetchProductSectionData(url.toString()).then((productData) => {
        if (!productData || !productData[sectionId]) return;

        const parsedDoc = new DOMParser().parseFromString(productData[sectionId], 'text/html');
        if (!parsedDoc) return;
        const badgesId = `badges-${sectionId}`;

        sections.forEach((id) => {
          let sourceElement, destination;

          if (id === badgesId) {
            destination = document.querySelector(`${selectedSlideSelector} .product-card--badges-pdp-wrapper`);
            sourceElement = parsedDoc.querySelector(`${selectedSlideSelector} .product-card--badges-pdp-wrapper`);
          } else {
            destination = document.getElementById(id);
            sourceElement = parsedDoc.getElementById(id);
          }

          if (!sourceElement || !destination) return;

          destination.innerHTML = sourceElement.innerHTML;
          if (id === badgesId && destination) destination.classList.remove('is-updating');

          const price = document.getElementById(id);
          const priceFixed = document.getElementById(id + '--sticky');
          if (price) price.classList.remove('visibility-hidden');
          if (priceFixed) priceFixed.classList.remove('visibility-hidden');
        });

        this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
      }).finally(() => {
        const wrapper = document.querySelector(`${selectedSlideSelector} .product-card--badges-pdp-wrapper`);
        if (wrapper) wrapper.classList.remove('is-updating');
      });
    }


    renderProductInfo() {
      const sections = this.getSectionsToRender();
      const selectedSlideSelector = this.badgesSlideSelector();

      const badgesId = `badges-${this.dataset.section}`;
      const badgesSelector = `${selectedSlideSelector} .product-card--badges-pdp-wrapper`;
      const variant = this.currentVariant;

      // Only the latest selection matters: an answer still on its way for a
      // previous variant is dropped instead of landing over the new one.
      this.productInfoRequest?.abort();

      const request = new AbortController();
      this.productInfoRequest = request;

      const badgesWrapper = document.querySelector(badgesSelector);
      if (badgesWrapper) badgesWrapper.classList.add('is-updating');

      fetch(`${this.dataset.url}?variant=${variant.id}&section_id=${this.dataset.section}`, { signal: request.signal })
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          sections.forEach((id) => {
            let destination, source;

            if (id === badgesId) {
              destination = document.querySelector(badgesSelector);
              source = html.querySelector(badgesSelector);
            } else {
              destination = document.getElementById(id);
              source = html.getElementById(id);
            }

            if (!source || !destination) return;
            destination.innerHTML = source.innerHTML;
            if (id === badgesId) destination.classList.remove('is-updating');

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');
          });
          this.toggleAddButton(!variant.available, window.theme.variantStrings.soldOut);
        })
        .catch((error) => {
          if (error.name !== 'AbortError') throw error;
        })
        .finally(() => {
          if (this.productInfoRequest !== request) return;

          this.productInfoRequest = null;
          const wrapper = document.querySelector(badgesSelector);
          if (wrapper) wrapper.classList.remove('is-updating');
        });
    }

    getAddToCartButtonLabel(productFormElement) {
      return productFormElement?.dataset?.buttonLabel || window.theme.variantStrings.addToCart;
    }

    getSubmitButtons(productForm) {
      return [
        ...productForm.querySelectorAll('.single-add-to-cart-button'),
        ...document.querySelectorAll(`button.single-add-to-cart-button[form="${productForm.id}"]`),
      ];
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productFormElement = productForm.closest('product-form');
      const productTemplate = productFormElement?.getAttribute('template');
      const submitButtons = this.getSubmitButtons(productForm);
      const bisEnabled = productForm.dataset.bisEnabled === 'true';

      if (!submitButtons || !submitButtons.length) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          if (text && bisEnabled) {
            // BIS enabled: switch button to notify-me mode
            submitButton.setAttribute('type', 'button');
            submitButton.removeAttribute('name');
            submitButton.removeAttribute('disabled');
            submitButton.classList.remove('sold-out', 'loading');
            submitButton.dataset.bis = 'true';
            submitButtonText.textContent =
              productForm.dataset.bisButtonText ||
              productForm.closest('.product-form')?.dataset?.bisButtonText ||
              '';
          } else {
            // Standard: disable and show sold-out text
            submitButton.setAttribute('disabled', 'disabled');
            if (text) submitButtonText.textContent = text;
          }
        } else {
          // Variant is available — restore ATC button
          submitButton.setAttribute('type', 'submit');
          submitButton.setAttribute('name', 'add');
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading', 'sold-out');
          delete submitButton.dataset.bis;

          if (productTemplate?.includes('pre-order')) {
            submitButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.textContent = this.getAddToCartButtonLabel(productFormElement);
          }
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      const submitButtons = productForm ? this.getSubmitButtons(productForm) : [];
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButtonText) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();


      if (variant_data) {
        let selected_options = false;
        if (this.currentVariant) {
          selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });
        } else {
          let found_option = variant_data.find(option => {
            return option.option1 === this.options[0];
          });
          if (found_option) {
            selected_options = [
              {
                "value": this.options[0],
                "index": "option1"
              },
              {
                "value": found_option.option2,
                "index": "option2"
              }
            ];
          } else {
            return;
          }
        }

        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

        const hasMultipleGroups = this.fieldsets.length > 1;

        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input) => {
                const matchedOption = fieldset_options.find(opt => opt.value === input.value);
                if (matchedOption) {
                  const shouldStyleAsDisabled = !hasMultipleGroups || i > 0;
                  if (shouldStyleAsDisabled) {
                    input.classList.toggle('is-disabled', matchedOption.isUnavailable);
                  }

                  if (i > 0) {
                    const optionKey = `option${i + 1}`;
                    const variantExists = variant_data.some(variant => {
                      if (variant[optionKey] !== input.value) return false;
                      for (const sel of selected_options) {
                        if (sel.index === optionKey) continue;
                        if (variant[sel.index] !== sel.value) return false;
                      }
                      return true;
                    });

                    const shouldHide = !variantExists;

                    const label = input.nextElementSibling?.tagName === 'LABEL' ? input.nextElementSibling : null;
                    const wrapper = input.parentElement?.classList.contains('product-form__input--color') ? null : input.closest('div[style*="position"]');
                    if (wrapper) {
                      wrapper.style.display = shouldHide ? 'none' : '';
                    } else {
                      input.style.display = shouldHide ? 'none' : '';
                      if (label) label.style.display = shouldHide ? 'none' : '';
                    }
                  }
                }
              });
            }
          }
        });

      }
      return true;
    }

    autoSelectVisibleColor() {
      const targetFieldsets = this.fieldsets.filter((f, index) => index > 0);

      for (const fieldset of targetFieldsets) {
        const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
        if (!checkedInput) continue;

        const isHidden = checkedInput.style.display === 'none' ||
          (checkedInput.closest('div[style*="position"]')?.style.display === 'none');

        if (!isHidden) continue;

        const firstVisible = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find(input => {
          const wrapper = input.parentElement?.classList.contains('product-form__input--color') ? null : input.closest('div[style*="position"]');
          if (wrapper) return wrapper.style.display !== 'none';
          return input.style.display !== 'none';
        });

        if (firstVisible && firstVisible !== checkedInput) {
          firstVisible.checked = true;
          firstVisible.dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
      }
      return false;
    }

    reorderVariantsByAvailability() {
      const variant_data = this.getVariantData();
      if (!variant_data) return;

      let selected_options = null;
      if (this.currentVariant) {
        selected_options = this.currentVariant.options.map((value, index) => ({
          value,
          index: `option${index + 1}`
        }));
      } else {
        let found_option = variant_data.find(option => option.option1 === this.options[0]);
        if (found_option) {
          selected_options = [
            { value: this.options[0], index: 'option1' },
            { value: found_option.option2, index: 'option2' }
          ];
        }
      }

      if (!selected_options) return;

      const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

      this.fieldsets.forEach((fieldset, i) => {
        const fieldset_options = Object.values(available_options)[i];
        if (!fieldset_options) return;

        const availabilityMap = new Map();
        fieldset_options.forEach(opt => availabilityMap.set(opt.value, opt.isUnavailable));

        if (fieldset.querySelector('select')) {
          this.reorderSelectOptions(fieldset, availabilityMap);
        } else if (fieldset.querySelectorAll('input[type="radio"]').length) {
          this.reorderRadioOptions(fieldset, availabilityMap);
        }
      });
    }

    reorderSelectOptions(fieldset, availabilityMap) {
      const select = fieldset.querySelector('select');
      if (!select) return;

      const selectedValue = select.value;
      const options = Array.from(select.querySelectorAll('option'));
      if (options.length < 2) return;

      const byOriginalIndex = (a, b) => {
        const ai = parseInt(a.getAttribute('data-original-index') || '0');
        const bi = parseInt(b.getAttribute('data-original-index') || '0');
        return ai - bi;
      };

      const available = options.filter(opt => !availabilityMap.get(opt.value));
      const unavailable = options.filter(opt => availabilityMap.get(opt.value));

      const sorted = [...available.sort(byOriginalIndex), ...unavailable.sort(byOriginalIndex)];

      sorted.forEach(opt => select.appendChild(opt));
      select.value = selectedValue;
    }

    reorderRadioOptions(fieldset, availabilityMap) {
      const groupedContainers = Array.from(
        fieldset.querySelectorAll('.product-form__color-group-swatches')
      );

      if (groupedContainers.length) {
        const byOriginalIndex = (a, b) => a.originalIndex - b.originalIndex;

        groupedContainers.forEach((groupContainer) => {
          const wrappers = Array.from(groupContainer.querySelectorAll(':scope > .product-form__color-group-swatch'));
          if (wrappers.length < 2) return;

          const items = wrappers
            .map((wrapper) => {
              const input = wrapper.querySelector(':scope > input[type="radio"]');
              if (!input) return null;
              return {
                wrapper,
                isUnavailable: availabilityMap.get(input.value) ?? false,
                originalIndex: parseInt(input.getAttribute('data-original-index') || '0')
              };
            })
            .filter(Boolean);

          const sorted = [
            ...items.filter((item) => !item.isUnavailable).sort(byOriginalIndex),
            ...items.filter((item) => item.isUnavailable).sort(byOriginalIndex)
          ];

          sorted.forEach((item) => {
            groupContainer.appendChild(item.wrapper);
          });
        });

        return;
      }

      const blockContainer = fieldset.querySelector('.product-form__input--block--options');
      const container = blockContainer || fieldset;

      const inputs = Array.from(container.querySelectorAll(':scope > input[type="radio"]'));
      if (inputs.length < 2) return;

      const byOriginalIndex = (a, b) => a.originalIndex - b.originalIndex;

      const pairs = inputs.map(input => {
        const nextEl = input.nextElementSibling;
        return {
          input,
          label: (nextEl && nextEl.tagName === 'LABEL') ? nextEl : null,
          isUnavailable: availabilityMap.get(input.value) ?? false,
          originalIndex: parseInt(input.getAttribute('data-original-index') || '0')
        };
      });

      const sorted = [
        ...pairs.filter(p => !p.isUnavailable).sort(byOriginalIndex),
        ...pairs.filter(p => p.isUnavailable).sort(byOriginalIndex)
      ];

      sorted.forEach(pair => {
        container.appendChild(document.createTextNode('\n'));
        container.appendChild(pair.input);
        if (pair.label) {
          container.appendChild(document.createTextNode('\n'));
          container.appendChild(pair.label);
        }
      });

      // Ensure dimension display stays at the end of the fieldset
      const dimensionEl = fieldset.querySelector('[class*="dimension"]');
      if (dimensionEl) fieldset.appendChild(dimensionEl);
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    getFieldsetByHandle(handle) {
      if (!handle) return null;
      return this.querySelector(`.product-form__input[data-handle="${handle}"]`);
    }

    resolveImageSet() {
      const slidesWithSet = this.productSlider.querySelectorAll('[data-set-name]');
      for (const slide of slidesWithSet) {
        const name = slide.dataset.setName;
        const fieldset = this.getFieldsetByHandle(name);
        if (fieldset?.dataset.index) {
          return { imageSetName: name, imageSetIndex: fieldset.dataset.index };
        }
      }

      const fieldsets = this.querySelectorAll('fieldset.product-form__input[data-handle]');
      for (const fieldset of fieldsets) {
        const handle = fieldset.dataset.handle;
        if (!handle || !fieldset.dataset.index) continue;
        if (this.productSlider.querySelector(`[data-set-name="${handle}"]`)) {
          return { imageSetName: handle, imageSetIndex: fieldset.dataset.index };
        }
      }

      return null;
    }

    setImageSet() {
      if (!this.productSlider) return;

      const resolved = this.resolveImageSet();

      if (!resolved) {
        this.imageSetName = null;
        this.imageSetIndex = null;
        delete this.dataset.imageSetIndex;
        return;
      }

      this.imageSetName = resolved.imageSetName;
      this.imageSetIndex = resolved.imageSetIndex;
      this.dataset.imageSetIndex = this.imageSetIndex;
      this.setImageSetMedia();
    }

    normalizeString(str) {
      if (!str) return '';

      return str
        .toLowerCase()
        .trim()
        .replace(/[àáâãäå]/g, 'a')
        .replace(/[èéêë]/g, 'e')
        .replace(/[ìíîï]/g, 'i')
        .replace(/[òóôõö]/g, 'o')
        .replace(/[ùúûü]/g, 'u')
        .replace(/[ñ]/g, 'n')
        .replace(/[ç]/g, 'c')
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
    }

    arraysMatch(variantGroup, imageGroup) {
      if (!variantGroup || !imageGroup || imageGroup.length === 0) return false;

      // Filtrar "dimension" de ambos os arrays antes de comparar
      const filteredVariantGroup = variantGroup.filter(val => val !== 'dimension');
      const filteredImageGroup = imageGroup.filter(val => val !== 'dimension');

      if (filteredImageGroup.length === 0) return false;

      return filteredImageGroup.every(val => filteredVariantGroup.includes(val));
    }

    // Função para extrair grupo de dados
    extractGroupFromDataset(datasetGroup, imageSetName) {
      if (!datasetGroup || !imageSetName) return [];

      const groupPart = datasetGroup.split(`${imageSetName}_`);
      if (groupPart.length < 2) return [];

      return groupPart[1].split('_').filter(Boolean);
    }

    isFeaturedMediaElement(el) {
      const featuredMediaId = this.currentVariant?.featured_media?.id;
      if (!featuredMediaId || !el) return false;

      const suffix = `${this.dataset.section}-${featuredMediaId}`;
      if (el.id === `Slide-${suffix}` || el.id === `Thumb-${suffix}`) return true;
      if (el.dataset?.mediaId === suffix) return true;

      return false;
    }

    toggleGroupActive(elements, normalizedGroup) {
      elements.forEach((el) => {
        const setName = el.dataset.setName;
        if (!setName || !el.dataset.group) return;

        const elementGroup = this.extractGroupFromDataset(el.dataset.group, setName);
        const isActive = this.arraysMatch(normalizedGroup, elementGroup) || this.isFeaturedMediaElement(el);

        el.classList.toggle('is-active', isActive);
      });
    }

    setImageSetMedia() {
      if (!this.currentVariant) {
        this.afterSetImageSetMedia();
        return;
      }

      const normalizedGroup = this.currentVariant.options.map((option) => this.normalizeString(option));

      if (this.hideVariants) {
        const slides = this.productSlider?.querySelectorAll('.product-images__slide[data-group]') ?? [];
        this.toggleGroupActive(slides, normalizedGroup);

        if (this.thumbnails && this.productWrapper) {
          const thumbs = this.productWrapper.querySelectorAll('.product-thumbnail[data-group]');
          this.toggleGroupActive(thumbs, normalizedGroup);
        }

        this.afterSetImageSetMedia();
        return;
      }

      if (!this.imageSetIndex || !this.imageSetName) {
        this.afterSetImageSetMedia();
        return;
      }

      if (!this.thumbnails) {
        const setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
        const group = `${this.imageSetName}_${setValue}`;
        const selectedSlides = this.productSlider.querySelectorAll(
          `.product-images__slide[data-set-name="${this.imageSetName}"]`
        );

        Array.from(selectedSlides)
          .filter((slide) => slide.dataset.group === group)
          .forEach((slide) => slide.parentElement.prepend(slide));
      }

      this.afterSetImageSetMedia();
    }
    afterSetImageSetMedia() {
      if (!this.thumbnails && this.showAllMedia !== 'featured' && this.displaySliderPagination) {
        setTimeout(() => {
          const sliderEl = this.productSlider.tagName.toLowerCase() === 'product-slider'
            ? this.productSlider
            : this.productSlider.querySelector('product-slider');
          if (sliderEl && typeof sliderEl.onPaginationResize === 'function') {
            sliderEl.onPaginationResize();
          }
        }, 100);
      }
    }

    createAvailableOptionsTree(variants, currentlySelectedValues) {
      // Reduce variant array into option availability tree
      return variants.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = { value: variant[index], isUnavailable: true };
            options[index].push(entry);
          }

          const currentOption1 = currentlySelectedValues.find(({ value, index }) => index === 'option1');
          const currentOption2 = currentlySelectedValues.find(({ value, index }) => index === 'option2');

          switch (index) {
            case 'option1':
              // Option1 inputs should always remain enabled based on all available variants
              entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              break;
            case 'option2':
              // Option2 inputs should remain enabled based on available variants that match first option group
              if (currentOption1 && variant.option1 === currentOption1.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
              break;
            case 'option3':
              // Option 3 inputs should remain enabled based on available variants that match first and second option group
              if (currentOption1 && variant.option1 === currentOption1.value && currentOption2 && variant.option2 === currentOption2.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
          }
        });

        return options;
      }, { option1: [], option2: [], option3: [] });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  if (window.ProductMediaManagerMixin) {
    Object.assign(VariantSelects.prototype, window.ProductMediaManagerMixin);
  }
  if (!customElements.get('variant-selects')) {
    customElements.define('variant-selects', VariantSelects);
  }
}

/**
 *  @class
 *  @function VariantRadios
 */
if (!window.VariantRadios) {
  window.VariantRadios = class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }
  if (!customElements.get('variant-radios')) {
    customElements.define('variant-radios', VariantRadios);
  }
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.pagination = this.parentElement.querySelector('.product-images-buttons');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      // Start Gallery
      let observer = new MutationObserver(() => {
        this.setupProductGallery();
      });

      observer.observe(this, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        characterData: false
      });

      this.setupProductGallery();

      // Start Pagination
      if (this.pagination) {
        this.setupPagination();
        this.resizeObserver = new ResizeObserver(entries => this.onPaginationResize());
        this.resizeObserver.observe(this);
        this.addEventListener('scroll', this.updatePagination.bind(this));
      }
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }

      this.setEventListeners();
    }
    buildItems(activeImages) {
      let images = activeImages.map((item) => {
        let activelink = item.querySelector('.product-single__media-zoom');
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          title: activelink.getAttribute('title')
        };
      });
      return images;
    }
    setEventListeners() {
      let activeImages = Array.from(this.querySelectorAll('.product-images__slide--image')).filter(element => element.clientWidth > 0),
        items = this.buildItems(activeImages),
        captionEl = this.dataset.captions,
        pswpElement = document.querySelectorAll('.pswp')[0],
        options = {
          maxSpreadZoom: 2,
          loop: false,
          allowPanToNext: false,
          closeOnScroll: false,
          showHideOpacity: false,
          arrowKeys: true,
          history: false,
          captionEl: captionEl,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: true,
          arrowEl: true,
          preloaderEl: true
        };

      let openPswp = function (e, link, options, pswpElement, items) {
        let parent = link.closest('.product-images__slide');
        let i = activeImages.indexOf(parent);
        options.index = parseInt(i, 10);
        options.getThumbBoundsFn = () => {
          const thumbnail = link.closest('.product-single__media'),
            pageYScroll = window.scrollY || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        };
        if (typeof PhotoSwipe !== 'undefined') {
          let pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

          pswp.listen('firstUpdate', () => {
            pswp.listen('parseVerticalMargin', function (item) {
              item.vGap = {
                top: 50,
                bottom: 50
              };
            });
          });
          pswp.init();
        }
        e.preventDefault();
      };
      this.querySelectorAll('.product-single__media-zoom').forEach(function (link) {
        let thumbnail = link.closest('.product-single__media');
        let clone = link.cloneNode(true);
        thumbnail.append(clone);
        link.remove();
        clone.addEventListener('click', (e) => openPswp(e, clone, options, pswpElement, items));
      });

      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
    }
    setupPagination() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

      this.currentPageElement = this.pagination.querySelector('.slider-counter--current');
      this.pageTotalElement = this.pagination.querySelector('.slider-counter--total');

      this.prevButton = this.pagination.querySelector('button[name="previous"]');
      this.nextButton = this.pagination.querySelector('button[name="next"]');


      this.prevButton.addEventListener('click', this.onPaginationButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onPaginationButtonClick.bind(this));

      this.updatePagination();
    }
    onPaginationResize() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);

      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.updatePagination();
    }
    onPaginationButtonClick(event) {
      event.preventDefault();
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.scrollLeft + (1 * this.sliderItemOffset) : this.scrollLeft - (1 * this.sliderItemOffset);
      this.scrollTo({
        left: this.slideScrollPosition
      });
    }
    updatePagination() {
      if (!this.nextButton) return;

      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.scrollLeft / this.sliderItemOffset) + 1;

      if (this.currentPageElement) {
        this.currentPageElement.textContent = this.currentPage;
      }
      if (this.pageTotalElement) {
        this.pageTotalElement.textContent = this.sliderItemsToShow.length;
      }

      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        }));
      }

      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.scrollLeft;
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (!this.form.reportValidity()) {
        return;
      }
      const submitButtons = Array.from(this.form.elements).filter(
        (element) => element.classList && element.classList.contains('single-add-to-cart-button')
      );

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
            submitButton.blur();
          });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      },
      {
        id: 'custom-cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.notesToggle();
          document.getElementById('Cart-Drawer')?.removeProductEvent();
        }
        if (section.id === 'Cart' && typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));



      let product_drawer = document.getElementById('Product-Drawer');
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.querySelector('.product-quick-images--container').classList.remove('active');
        document.body.classList.remove('open-quick-view');

        if (window.innerWidth < 1069) {
          product_drawer.classList.remove('active');
          if (document.getElementById('Cart-Drawer')) {
            document.getElementById('Cart-Drawer').classList.add('active');
            document.body.classList.add('open-cart');
            document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
            dispatchCustomEvent('cart-drawer:open');
          }
        } else {
          product_drawer.querySelector('.product-quick-images--container').addEventListener('transitionend', function () {
            product_drawer.classList.remove('active');

            if (document.getElementById('Cart-Drawer')) {
              document.getElementById('Cart-Drawer').classList.add('active');
              document.body.classList.add('open-cart');
              document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
              dispatchCustomEvent('cart-drawer:open');
            }
          });
        }

        if (!document.getElementById('Cart-Drawer')) {
          document.body.classList.remove('open-cc');
        }
      } else if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      this.setupObservers();
      this.setupToggle();
    }
    setupObserversV2() {
      const holder = document.querySelector('#product-form-' + this.dataset.section + ' .add_to_cart_holder');
      const footer = document.getElementById('footer') || document.getElementById('custom-footer');
      if (!holder) return;

      let holderVisible = true;
      let footerVisible = false;
      const update = () => {
        this.classList.toggle('sticky--visible', !holderVisible && !footerVisible);
      };
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === holder) holderVisible = entry.isIntersecting;
          if (footer && entry.target === footer) footerVisible = entry.isIntersecting;
        });
        update();
      }, { threshold: 0 });

      observer.observe(holder);
      if (footer) observer.observe(footer);
    }
    setupToggle() {
      if (this.classList.contains('hide-colors')) {
        return;
      }

      const button = this.querySelector('.product-add-to-cart-sticky--inner'),
        content = this.querySelector('.product-add-to-cart-sticky--content');

      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            button.classList.add('sticky-open');
          },
          onReverseComplete: () => {
            button.classList.remove('sticky-open');
          }
        });

        tl
          .set(content, {
            display: 'block',
            height: 'auto'
          }, 'start')
          .from(content, {
            height: 0,
            duration: 0.25
          }, 'start+=0.001');

        button.addEventListener('click', function () {
          tl.reversed() ? tl.play() : tl.reverse();

          return false;
        });
      } else {
        button.addEventListener('click', function () {
          content.classList.toggle('active');
          return false;
        });
      }


    }
    revealWhenShopPayReady() {
      const show = () => this.classList.add('sticky--visible');
      const ready = () => {
        const button = this.querySelector('shop-pay-wallet-button');
        return !this.querySelector('.tdbuynow') || (button && button.offsetHeight > 0);
      };
      if (ready()) return show();

      const timer = setInterval(() => {
        if (!ready()) return;
        clearInterval(timer);
        show();
      }, 100);
      setTimeout(() => {
        clearInterval(timer);
        show();
      }, 8000);
    }
    setupObservers() {
      if (this.dataset.stickyVersion === 'v2') {
        if (window.matchMedia('(max-width: 767px)').matches) {
          this.revealWhenShopPayReady();
          return;
        }
        this.setupObserversV2();
        return;
      }

      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer') || document.getElementById('custom-footer');
      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}
